import React, { useEffect, useState } from "react";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import {
  Box,
  Grid,
  // Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  // Button,
  TextField,
  useMediaQuery 
} from "@mui/material";

import { Formik, Form } from "formik";
import { addObjectiveSchema } from "../../StaticData";
import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import { useSelector } from "react-redux";
// import DySplitButton from "../../../../components/GlobalComponents/DySplitButton/DySplitButton";
import AccordionLyt from "../../../../components/Layouts/AccordionLyt/AccordionLyt";
import { addObjectiveFace } from "../../Interfaces/Interfaces";
// import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
// import GroupedMultiSel from "../../../../components/FormikControls/GroupedMultiSel/GroupedMultiSel";
import {
  useGetAllObjectiveDefinitionLevelByTenantId,
  useGetAllObjectiveOKRStateByTenantId,
  useAddObjective,
  useGetAllObjectiveNameWithKeyResultsByTenantId,
  useGetAllTeamAndPersonNameByTenantId,
} from "../../Hooks";
import { useGetAllActivePersonByTenantId } from "../../Hooks";
// import { CircularProgress } from "@mui/material";
import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
// import { useGetPriodById } from "../../../../components/Login/Hooks/Index";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
// import MultiSel from "../../../../components/MultiSel/MultiSel";
import VerticalAlignments from "../../new/verticalAlignments";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { AddObjectiveData } from "../../Api";
import CustomeMultiSelect from "../../new/customeMultiSelect";
import { ErrorMessage } from "formik";
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
//Naderi
import { NewUseStore } from "../../../../Store/newUseStore";
// import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // این فایل استایل Quill را وارد می‌کند
import { useGetAllStrategies ,useGetAllStrategicBAUByTenantId, useGetMaxObjective} from "../../../MissionAndStrategy/Hooks";
import MyEditor from "../CreateKeyResult/MyEditor";
//
interface teamIdsFace {
  teamId: string;
  personIds: string[];
}
// allIds

const CreateObjective = ({
  periodsData,
  onSuccess,
  setShowToastMessage,
  setObjectiveAsyncOpState,
  afterSuccess,
  onClose,
  periodId, //AMIR
}: any) => {
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);
  // const [periodId, setLocalPeriosId] = useState<string>(periodId);
  const [showVerticalAlignment, setShowVerticalAlignment] =
    useState<boolean>(false);
  const [showMultiSelect, setShowMultiSelect] = useState<boolean>(false);
  const [objNameIds, setObjNameIds] = useState<any>({
    tenantId: tenantId,
    periodId: periodId,
    definitionLevelId: null,
  });
  const { data: ObjectiveNameOptions } =
    useGetAllObjectiveNameWithKeyResultsByTenantId(objNameIds);
    const isMobile = useMediaQuery("(max-width: 600px)"); // بررسی اندازه صفحه برای موبایل

  const {data:strategiesOptions,isLoading:getstrategyDataLoading}=useGetAllStrategies(tenantId,periodId);
  const {data:max,isLoading:getstrategyDataLoading1}=useGetMaxObjective(tenantId,periodId);
  const {data:bauData,isLoading:gettenantIndexLoading}=useGetAllStrategicBAUByTenantId(tenantId,periodId);
  const { data: teamsOptions, isLoading: teamOPloading } =
    useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
  const { data: personsOptionds } = useGetAllActivePersonByTenantId(tenantId);
  const { data: submitOptions } =
    useGetAllObjectiveOKRStateByTenantId(tenantId);
    const [description, setDescription] = useState<string>('');

    const handleChange = (value: string) => {
      setDescription(value);
    };
  
  const [verticalAlignmentBaseData, setVerticalAlignmentBaseData] =
    useState<any>([]);

  const updateObjectiveChanged = NewUseStore(
    (state) => state.updateObjectiveChanged
  );

  const[strategyData,setStrategyData]=useState(null);
  useEffect(() => {
    if (strategiesOptions) {
      setStrategyData(strategiesOptions.map(({ name, id }: any,i:number) => {
        return { key:  (i+1) + "." + name + "      ", value: id };
      }));
    }
  }, [strategiesOptions]);
  const [periodOptions, setPeriodOptions] = useState<any>([]);
  const [horzinalAliIds, setHorzinalAliIds] = useState<any[]>([]);
  const [allIds, setAllIds] = useState<any>([]);
  const [okrStateId, setOkrStateId] = useState<string>("");
  const [lIsPublic, setlIsPublic] = useState<any>(false);
  const [parentType, setParentType] = useState<any>();
  const [indxsId, setIndxsId] = useState<any>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [addObjError, setAddObjError] = useState<any>(null);
  const [isSubmittingForm, setIsSubmittingForm] = useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = React.useState<any>([]);
  const[indexData,setIndexData]=useState([])
  useEffect(() => {
    if(bauData !== null && bauData !== undefined ){
      var o = bauData?.map((item:any)=>{
        let{id,name}=item;
        return {year:id,title:name}
      })
      setIndexData(o);
    }
  }, [bauData]);
  const [teamName, setTeamName] = useState<any>({
    teamName: null,
  });

  const [allTeamAndPersonBaseData, setAllTeamAndPersonBaseData] = useState<any>(
    []
  );
  const { data: allTeamAndPersonData }: any =
    useGetAllTeamAndPersonNameByTenantId(tenantId);

  const onSuccessInAddObjective = () => {
    afterSuccess();
    // onSuccess((prev:any)=>!prev)
  };

  const parentTypeData = [
    { key: "استراتژی", value: "Strategy" },
    { key: "شاخص استراتژیک", value: "Index" },
    { key: "ندارد", value: "None" },
  ];

  const onErrorInAddObjective = (data: string) => {
    const Err = { isSuccess: false, metaData: { message: data.toString() } };
    setAddObjError(Err);
    setShowLtoastMessage(true);
  };
  const {
    mutate: addObjective,
    data: addObjectiveData,
    isSuccess,
    isLoading,
    isError: isErrorInAddObjective,
  } = useAddObjective(onErrorInAddObjective, onSuccessInAddObjective);

  useEffect(() => {
    if (addObjectiveData) {
      if (addObjectiveData?.data.isSuccess) {
        // setSuccessAddObjective(isSuccess)
        setShowToastMessage(true);
        setObjectiveAsyncOpState(addObjectiveData?.data);
        onSuccess();
      } else {
        setShowLtoastMessage(true);
        setAddObjError(addObjectiveData?.data);
      }
    }
  }, [addObjectiveData]);

  const addObjectiveInitialValues: addObjectiveFace = {
    name: "",
    periodId: periodId,
    calculateProgressType: "BasedOnKR",
    // createById:'',
    definitionLevelId: "",
    description: "",
    isPublic: true,
    keyResultParentIds: [],
    responsibleId: "",
    allIds: [],
    tenantId: "",
    weight: null,
    displayPriority: !getstrategyDataLoading1 ? (max?.count)?.toString() : 0,
    answerRequest: '',
  };

  const initialAddObjective = async (data: any) => {
    // let { isPublic } = data;
    setIsSubmittingForm(true);
    try {
      const verticalAlignmentLocal: Array<string> = [];
      verticalAlignmentBaseData.map((group: any) => ({
        ...group,
        items: group.items.map(
          (item: any) => item.checked && verticalAlignmentLocal.push(item.id)
        ),
      }));

      const allTeamAndPersonDataLocal: Array<string> = [];
      if (!data.isPublic)
        allTeamAndPersonBaseData.map(
          (item: any) => item.checked && allTeamAndPersonDataLocal.push(item.id)
        );

      //let resIsPublic = { isPublic: isPublic === "برای همه" ? true : false };
      let total = {
        ...data,
        weight: data.weight !== "" ? data.weight : null,
        displayPriority: data.displayPriority !== "" ? data.displayPriority : null,
        tenantId: tenantId,
        keyResultParentIds: verticalAlignmentLocal,
        parentId:selectedRowData,
        parentIds:indxsId,
        allIds: allTeamAndPersonDataLocal,
        okRStateId: okrStateId,
      };

      //addObjective(total);
      const retVal = await AddObjectiveData(total);
      let MessageObg;
      setShowLtoastMessage(true);
      //Naderi 14030526
      if (retVal.data && retVal.data.isSuccess) {
        // MessageObg = {
        //   isSuccess: true,
        //   metaData: { message: "ثبت با موفقیت انجام پذیرفت" },
        // };
        updateObjectiveChanged({
          show: true,
          state: true,
          message: "عملیات با موفقیت انجام شد",
        });
        afterSuccess();
        onClose();
      } else {
        // MessageObg = {
        //   isSuccess: false,
        //   metaData: { message: retVal.data.metaData.message },
        // };
        updateObjectiveChanged({
          show: true,
          state: false,
          message: retVal.data.metaData.message,
        });
      }
      setAddObjError(MessageObg);
    } catch (error) {
      setShowLtoastMessage(true);
      const MessageObg = {
        isSuccess: false,
        metaData: { message: "خطا در ثبت اطلاعات" },
      };
      setAddObjError(MessageObg);
    }
    setIsSubmittingForm(false);
  };
  //
  
  useEffect(() => {
    let transformed = periodsData?.map((item: any) => {
      let { name: key, id: value } = item;
      return { key, value };
    });
    setPeriodOptions(transformed);
  }, []);

  useEffect(() => {
    if (ObjectiveNameOptions) {
      const localVerticalAlignmentBaseData = ObjectiveNameOptions.map(
        (group: any) => ({
          ...group,
          items: group.items.map((item: any) => ({ ...item, checked: false })),
        })
      );

      setVerticalAlignmentBaseData(localVerticalAlignmentBaseData);
    }
    if (allTeamAndPersonData) {
      const localAllTeamAndPersonBaseData = allTeamAndPersonData.map(
        (item: any) =>
          allIds && allIds.findIndex((vItem: any) => vItem.id === item.id) > -1
            ? { ...item, checked: true }
            : { ...item, checked: false }
      );

      setAllTeamAndPersonBaseData(localAllTeamAndPersonBaseData);
    }
  }, [ObjectiveNameOptions]);

  // if (isLoading) {
  //   return <Box width={'100%'} py={6} textAlign={'center'}   >
  //       <CircularProgress/>
  //   </Box>
  // }

  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        <Formik
          enableReinitialize
          validationSchema={addObjectiveSchema}
          validate={(data) => {
            let { definitionLevelId, responsibleId, isPublic }: any = data;
            setlIsPublic(isPublic);
            if (isPublic === "برای همه") {
              setAllIds([]);
            }
          }}
          initialValues={{ ...addObjectiveInitialValues }}
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container>
              <Grid item xs={12} md={12}>
              <FormikControl
                control="textField"
                type="text"
                label={
                  <span>
                  {/* <span style={{ color: "red", marginLeft: 2 }}>*</span> */}
                    شرح هدف
                  </span>
                }
                name="name"
                fullWidth
                values={values?.name || ""}
              />
            </Grid>


                <Grid item xs={12} md={3} mt={1}>
                  <Box sx={{ padding: "8px" }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        دوره زمانی
                      </InputLabel>
                      <Select
                        defaultValue={periodId}
                        size="small"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={values?.periodId || ""}
                        label="دوره زمانی"
                        onChange={({ target }: any) => {
                          let { value } = target;
                          setFieldValue("periodId", value);
                          setObjNameIds((prev: any) => ({
                            ...prev,
                            periodId: value,
                          }));
                        }}
                      >
                        {periodOptions.map((item: any, i: number) => {
                          let { key, value, desc } = item;
                          return (
                            <MenuItem
                              key={i}
                              sx={{
                                fontSize: "0.7rem",
                                bgcolor: "transparent",
                              }}
                              value={value}
                            >
                              {key}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                
                </Grid>

                <Grid item xs={12} md={4} mt={1}>
                  <Box padding={"8px"}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="demo-simple-select-label">تیم</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-selectd"
                        value={values?.definitionLevelId || ""}
                        label="تیم"
                        onChange={(e: any, other: any) => {
                          let { props } = other;

                          let {
                            children: keyName,
                            content,
                            value: propsValue,
                          } = props;
                          setTeamName((prev: any) => ({
                            ...prev,
                            teamName: keyName,
                          }));
                          if (!content) {
                            setObjNameIds((prev: any) => ({
                              ...prev,
                              definitionLevelId: propsValue,
                            }));
                          }
                          let { target } = e;
                          let { value } = target;
                          setFieldValue("definitionLevelId", value);
                        }}
                      >
                        {teamOPloading && (
                          <Box width={"100%"} textAlign={"center"}>
                            <DyLoadingCircular />
                          </Box>
                        )}

                        {teamsOptions &&
                          teamsOptions.map((item: any) => {
                            let { key, value, isCompany } = item;
                            return (
                              <MenuItem
                                key={key}
                                value={value}
                                content={isCompany}
                              >
                                {key}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Box>
                  
                </Grid>

                {teamName?.teamName !== null &&
                teamName?.teamName !== "شرکت" ? (
                  <Grid xs={12} md={5} mt={1}>
                    <div className=" relative cursor-pointer ">
                      <div
                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                          e.preventDefault();
                          setShowVerticalAlignment(!showVerticalAlignment);
                        }}
                        className={` px-2 w-[98%] py-2 mt-1 flex justify-between text-xs font-thin text-black 
                        
                          rounded-md  ml-3 border-2 ${
                            showVerticalAlignment
                              ? "border-sky-600"
                              : "border-slate-200"
                          }   `}
                      >
                        همسویی عمودی
                        {showVerticalAlignment ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )}
                      </div>

                      {showVerticalAlignment && verticalAlignmentBaseData && (
                        <div className="absolute w-[98%] top-full right-0">
                          <VerticalAlignments
                            data={verticalAlignmentBaseData}
                            setShowVerticalAlignment={setShowVerticalAlignment}
                            setCheckBoxes={(id: string) => {
                              let tmpData: any = verticalAlignmentBaseData.map(
                                (group: any) => ({
                                  ...group,
                                  items: group.items.map((item: any) =>
                                    item.id === id
                                      ? { ...item, checked: !item.checked }
                                      : { ...item }
                                  ),
                                })
                              );
                              setFieldValue("keyResultParentIds", ["isDirty"]);
                              setVerticalAlignmentBaseData(tmpData);
                            }}
                          ></VerticalAlignments>
                        </div>
                      )}
                    </div>
                  </Grid>
                ) : (
                  <>
                  <Grid item xs={12} md={12}>
                              <FormikControl
                                control="select"
                                type="select"
                                label="نوع والد "
                                options={parentTypeData}
                                name="parentType"
                                onChange={(e: any, other: any) => {
                                  let { target } = e;
                                  let { value } = target;
                                  setFieldValue("parentType", value);
                                  setParentType(value);
                                  setSelectedRowData([]);
                                }}
                                fullWidth
                              />
                            

                </Grid>

                <Grid item xs={12} md={12}>
                <Grid item xs={12} md={12}>
                  <div>
                          {parentType === "Strategy" ? 
                              <div className=" relative cursor-pointer ">
                                <Grid item xs={12} md={6} >
                                    <div className='error'>
                                    {/* <ErrorMessage name="categoryIds" /> */}
                                    </div>
                                    {/* <MultiSelect
                                      options={strategyData || []}
                                      // options={strategiesOptions || []}
                                      isLoading={getstrategyDataLoading}
                                      // onChangee={setFieldValue}
                                      propName='parentId'
                                      label="استراتژی"
                                      onChangee={(e: any, other: any) => {
                                        // let { target } = e;
                                        // let { value } = target;
                                        // setParentId(value);
                                        setSelectedRowData(other);
                                      }}
                                    /> */}
                                     <FormikControl
                                      control="select"
                                      options={strategyData || []}
                                      // options={strategiesOptions || []}
                                      isLoading={getstrategyDataLoading}
                                      // onChangee={setFieldValue}
                                      name='parentIds'
                                      label="انتخاب استراتژی"
                                      onChange={(e: any, other: any) => {
                                        let { target } = e;
                                        let { value } = target;
                                        // let myList: string[] = [];
                                        // myList.push(value)
                                        // setSelectedRowData(myList);
                                        setIndxsId(value);
                                      }}
                                    />
                                </Grid>        
                              </div>
                              :
                              <div className=" relative cursor-pointer ">
                              </div>
                          }
                  </div>
                </Grid>

                <Grid item xs={12} md={12}>
                  <div>
                          {parentType === "Index" ? 
                              <div className=" relative cursor-pointer ">
                                <Grid item xs={12} md={6} >
                                    <div className='error'>
                                    {/* <ErrorMessage name="categoryIds" /> */}
                                    </div>
                                    <MultiSelect
                                      options={indexData || []}
                                      isLoading={gettenantIndexLoading}
                                      //onChangee={setFieldValue}
                                      propName='parentId'
                                      label="شاخص استراتژیک"
                                      onChangee={(e: any, other: any) => {
                                        // let { target } = e;
                                        // let { value } = target;
                                        // setParentId(value);
                                        setSelectedRowData(other);
                                      }}
                                    />
                                </Grid>        
                              </div>
                              :
                              <div className=" relative cursor-pointer ">
                              </div>
                          }
                  </div>
                </Grid>
                </Grid>
                  </>
                )}

                <Grid item xs={12} md={4} mt={1}>
                  <FormikControl
                    control="select"
                    options={personsOptionds || []}
                    label="مسئول هدف"
                    name="responsibleId"
                    fullWidth
                    values={values?.responsibleId || ""}
                  />
                </Grid>

                <div className="w-full ">
                  <AccordionLyt
                    collapse={setShowAdvanceOptions}
                    title={" تنظیمات پیشرفته ( اختیاری)"}
                    expanded={showAdvanceOptions}
                  >
                    <div className="w-full flex-col justify-start text-xs items-start ">
                      <div className="h-11 w-full flex gap-x-8 items-center">
                        <span className="w-1/6 ">قابلیت نمایش:</span>
                        <label className="flex gap-x-2 w-1/6 items-center">
                          <input
                            type="radio"
                            className="radio radio-xs"
                            name="forAll"
                            value="forAll"
                            id="forAll"
                            onChange={() => setFieldValue("isPublic", true)}
                            checked={values?.isPublic}
                          />
                          <span className=" text-xs">برای همه</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-2/6">
                          <input
                            type="radio"
                            className="radio radio-xs"
                            name="forCertain"
                            value="forCertain"
                            id="forCertain"
                            onChange={() => setFieldValue("isPublic", false)}
                            checked={!values?.isPublic}
                          />
                          <span className=" text-xs">
                            برای اشخاص و تیم های خاص
                          </span>
                        </label>
                        <div className="w-3/6">
                          {!values?.isPublic && allTeamAndPersonBaseData && (
                            <div className=" relative cursor-pointer ">
                              <div
                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                  e.preventDefault();
                                  setShowMultiSelect(!showMultiSelect);
                                }}
                                className={` px-2 w-[98%] py-2 mt-1 flex justify-between text-xs font-thin text-black 
                               
                                 rounded-md  ml-3 border-2 ${
                                   showMultiSelect
                                     ? "border-sky-600"
                                     : "border-slate-200"
                                 }   `}
                              >
                                برای اشخاص و تیم های خاص
                                {showMultiSelect ? (
                                  <ArrowDropUpIcon />
                                ) : (
                                  <ArrowDropDownIcon />
                                )}
                              </div>

                              {showMultiSelect && allTeamAndPersonBaseData && (
                                <div className="absolute w-[98%] top-full right-0">
                                  <CustomeMultiSelect
                                    data={allTeamAndPersonBaseData}
                                    setShowMultiSelect={setShowMultiSelect}
                                    title="برای اشخاص و تیم های خاص"
                                    setCheckBoxes={(id: string) => {
                                      let tmpData: any =
                                        allTeamAndPersonBaseData.map(
                                          (item: any) =>
                                            item.id === id
                                              ? {
                                                  ...item,
                                                  checked: !item.checked,
                                                }
                                              : { ...item }
                                        );
                                      setFieldValue("allIds", ["isDirty"]);
                                      setAllTeamAndPersonBaseData(tmpData);
                                    }}
                                  ></CustomeMultiSelect>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="h-11 w-full flex  items-center">
                        <span className="w-1/6">نحوه محاسبه پیشرفت:</span>
                        <label className="flex gap-x-2 w-2/6 items-center">
                          <input
                            type="radio"
                            className="radio radio-xs"
                            name="BasedOnKR"
                            value="BasedOnKR"
                            id="BasedOnKR"
                            onChange={() =>
                              setFieldValue(
                                "calculateProgressType",
                                "BasedOnKR"
                              )
                            }
                            checked={
                              values?.calculateProgressType === "BasedOnKR"
                            }
                          />
                          <span className=" text-xs">بر اساس okr های همسو</span>
                        </label>
                        <label className="flex gap-x-2 items-center w-2/6">
                          <input
                            type="radio"
                            className="radio radio-xs"
                            name="BasedOnAlignedOKRs"
                            value="BasedOnAlignedOKRs"
                            id="BasedOnAlignedOKRs"
                            onChange={() =>
                              setFieldValue(
                                "calculateProgressType",
                                "BasedOnAlignedOKRs"
                              )
                            }
                            checked={
                              values?.calculateProgressType ===
                              "BasedOnAlignedOKRs"
                            }
                          />
                          <span className=" text-xs">
                            بر اساس تحقق نتایج کلیدی
                          </span>
                        </label>
                      </div>

                      {/* <Grid item xs={12} md={6}>
                          <FormikControl
                            control={"radio"}
                            mainLabel={"قابلیت نمایش"}
                            value={values?.isPublic}
                            setFieldValue={setFieldValue}
                            propName={"isPublic"}
                            options={[
                              { label: "برای همه", value: "برای همه" },
                              {
                                label: "برای اشخاص و تیم های خاص",
                                value: "برای اشخاص و تیم های خاص",
                              },
                            ]}
                          />
                        </Grid>

                        */}

                      {/* <Grid item xs={12} md={12}>
                          <FormikControl
                            setFieldValue={setFieldValue}
                            control={"radio"}
                            propName={"calculateProgressType"}
                            mainLabel={"نحوه محاسبه پیشرفت:"}
                            options={[
                              {
                                label: "بر اساس okr های همسو",
                                value: "ForSpecialPeople",
                              },
                              {
                                label: "بر اساس تحقق نتایج کلیدی",
                                value: "BasedOnKR",
                              },
                            ]}
                          />
                        </Grid> */}
                    </div>

                    <Grid container>
                      <Grid item xs={12} md={2}>
                        <Box>
                          <div className="error">
                            <ErrorMessage name="weight" />
                          </div>
                          <FormikControl
                            control="textField"
                            size="small"
                            label="وزن"
                            name="weight"
                            fullWidth
                            value={values?.weight || ""}
                            type={"number"}
                            onChange={({ target }: any) => {
                              let { value } = target;
                              setFieldValue("weight", value);
                            }}
                          />
                        </Box>
                      </Grid>
                        <Grid item xs={12} md={2}>
                        <Box sx={{ padding: "8px", fontSize: 10 }}>
                        <TextField
                        sx={{ fontSize: 10 }}
                        size="small"
                        type="number" // نوع فیلد را به عدد تغییر دادیم
                        label="اولویت نمایش" // عنوان فیلد
                        name="displayPriority" // نام فیلد
                        fullWidth
                        value={values?.displayPriority || ""} // مقدار فیلد
                        onChange={({ target }: any) => {
                        let { value } = target;
                        setFieldValue("displayPriority", value); // به‌روزرسانی مقدار فیلد
                        }}
                        />
                        </Box>
                        </Grid>
                      <Grid item xs={12} md={8}>
                        <Box sx={{ padding: "8px", fontSize: 10 }}>
                          <TextField
                            sx={{ fontSize: 10 }}
                            size="small"
                            type="text"
                            label="دلیل اهمیت"
                            name="answerRequest"
                            fullWidth
                            value={values?.answerRequest || ""}
                            onChange={({ target }: any) => {
                              let { value } = target;
                              setFieldValue("answerRequest", value);
                            }}
                          />
                          {/* TheReasonImportant */}
                        </Box>
                      </Grid>
                     


                      <Grid item xs={12} md={12}>
                      {/* <Box sx={{ padding: "8px" }}> */}
                        <MyEditor
                          values={values}  
                          setFieldValue={setFieldValue}  
                        />
                      {/* <FormikControl
                        control='textField'
                        type='text'
                        label='توضیحات'
                        name='description'
                        fullWidth
                        value={values?.description || ''}
                        placeholder={'توضیحات (اختیاری)  0/300'}
                      />
                      </Box> */}
                      </Grid>
                    </Grid>
                  </AccordionLyt>
                </div>

                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                    {submitOptions &&
                      submitOptions?.map((item: any, i: number) => {
                        let { label, id } = item;
                        // console.log(item)
                        return (
                          <Box 
                          width={isMobile ? "45%" : "20%"} // در موبایل عرض کوچکتر
>
                            <DyButton
                              disabled={!dirty || !isValid || isSubmittingForm}
                              key={i}
                              type={"submit"}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={label}
                              onClick={() => {
                                setOkrStateId(id);
                              }}
                              sx={{
                                fontSize: isMobile ? "0.8rem" : "1rem", // در موبایل فونت کوچکتر
                                padding: isMobile ? "6px 12px" : "10px 20px", // در موبایل padding کوچکتر
                              }}
                            />
                          </Box>
                        );
                      })}
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {/* {showLtoastMessage && (
          <DYToastMessage
            isSuccess={addObjError?.isSuccess}
            message={addObjError?.metaData.message}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )} */}
      </Box>
    </>
  );
};

export default CreateObjective;
